import React, { useEffect, useState } from 'react';
import { FiClock } from 'react-icons/fi';
import TIA from 'src/app/components/TIA';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import { GuideCard, GuideCardCheck, GuideCardContent, GuideCardIcon, GuideCardTime, GuideCardTitle } from '@/components/custom/guide';
import { BadgeTruncate } from '@/components/ui/badge';

export function StudyGuideCard(props) {
  const navigate = useNavigate();
  const { done, title, isCurrent, video, guide_index, canBeClicked = false } = props;

  const client = useClient();
  const [tiaMessageProgressMarch, setTiaMessageProgressMarch] = useState(null);

  const getTiaMessageBlock = async id => {
    const response = await client.mutate(`study_plan_videos/${id}/tia_message_blocks`, {}, { method: 'post' });
    return response.data;
  };

  useEffect(() => {
    if (isCurrent) {
      getTiaMessageBlock(video.id).then(data => {
        setTiaMessageProgressMarch(data?.body);
      });
    }
  }, []);

  const clockIconsCount = guide_index % 2 === 0 ? 3 : 2;
  const clockIcons = Array.from({ length: clockIconsCount }, (_, index) => (
    <GuideCardIcon>
      <FiClock key={index} />
    </GuideCardIcon>
  ));

  return (
    <GuideCard
      isCurrent={isCurrent}
      onClick={() => {
        if (canBeClicked) navigate(`/guia-de-estudos/bloco-de-estudo/${video.id}`);
      }}
      style={{ cursor: canBeClicked ? 'pointer' : 'not-allowed' }}
    >
      <GuideCardCheck
        name="done"
        checked={done}
        readOnly
      />

      <GuideCardContent>
        <GuideCardTitle>{title}</GuideCardTitle>

        <BadgeTruncate
          items={video.video?.taxonomies}
          oneLine
        />
      </GuideCardContent>

      <GuideCardTime>{clockIcons}</GuideCardTime>

      {isCurrent && tiaMessageProgressMarch && <TIA message={tiaMessageProgressMarch} />}
    </GuideCard>
  );
}
